// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IInterestRateTemplateDto } from './IInterestRateTemplateDto';
import {
    IInterestRateTemplateDtoFromJSON,
    IInterestRateTemplateDtoFromJSONTyped,
    IInterestRateTemplateDtoToJSON,
    IInterestRateTemplateDtoToJSONTyped,
} from './IInterestRateTemplateDto';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageInterestRateTemplateDto
 */
export interface IPageInterestRateTemplateDto {
    /**
     * 
     * @type {number}
     * @memberof IPageInterestRateTemplateDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageInterestRateTemplateDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageInterestRateTemplateDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IInterestRateTemplateDto>}
     * @memberof IPageInterestRateTemplateDto
     */
    content?: Array<IInterestRateTemplateDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageInterestRateTemplateDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageInterestRateTemplateDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageInterestRateTemplateDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageInterestRateTemplateDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageInterestRateTemplateDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageInterestRateTemplateDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageInterestRateTemplateDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageInterestRateTemplateDto interface.
 */
export function instanceOfIPageInterestRateTemplateDto(value: object): value is IPageInterestRateTemplateDto {
    return true;
}

export function IPageInterestRateTemplateDtoFromJSON(json: any): IPageInterestRateTemplateDto {
    return IPageInterestRateTemplateDtoFromJSONTyped(json, false);
}

export function IPageInterestRateTemplateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageInterestRateTemplateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IInterestRateTemplateDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageInterestRateTemplateDtoToJSON(json: any): IPageInterestRateTemplateDto {
    return IPageInterestRateTemplateDtoToJSONTyped(json, false);
}

export function IPageInterestRateTemplateDtoToJSONTyped(value?: IPageInterestRateTemplateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IInterestRateTemplateDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

